const productionServer1 = "https://restaurantnlp.herokuapp.com";
const productionServer2 = "https://chatnlp.herokuapp.com";
let productionCurrent = "";

const date = new Date().getDate();

if (date < 16) {
  productionCurrent = productionServer1
} else {
  productionCurrent = productionServer2
}

module.exports = {
  baseUrl: (window.location.href.includes("localhost")) ?
    "http://localhost:7001"
    :
    // productionCurrent
    ""
}